export const api_host = process.env.VUE_APP_API_HOST
export const viewer_url = process.env.VUE_APP_VIEWER_URL || ''
